import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import axios from 'axios';

const ProtectedRoute = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const { userCookies } = useAuth();
  return userCookies ? <Outlet /> : <Navigate to="/login" />;

  // useEffect(() => {
  //   const checkMaintenanceMode = async () => {
  //     try {
  //       const response = await axios.get('/core/settings/0/');
  //       setIsMaintenanceMode(response.data.maintenance_mode || false);
  //     } catch (error) {
  //       console.error('Error checking maintenance mode:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (userCookies) {
  //     checkMaintenanceMode();
  //   } else {
  //     setLoading(false);
  //   }
  // }, [userCookies]);

  // if (loading) {
  //   return null;
  // }

  // if (!userCookies) {
  //   return <Navigate to="/login" />;
  // }

  // if (isMaintenanceMode && userCookies && userCookies.is_superuser !== true) {
  //   return <Navigate to="/maintenance" />;
  // }

  // return <Outlet />;
};

export default ProtectedRoute;
